import { ActionIcon, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

interface InfoHintProps {
    label: string;
    width?: number;
    size?: number;
    /** Visual position relative to the trigger. Defaults to "top". */
    position?: "top" | "bottom" | "left" | "right";
}

/**
 * Small `?`-icon trigger that surfaces a hover/focus/tap tooltip explaining a
 * non-obvious affordance. Mirrors AC DRIVE's "How to gift to others?" pattern
 * but uses a real Mantine Tooltip (a11y + multi-line + dark theme aware).
 */
export function InfoHint({ label, width = 240, size = 14, position = "top" }: InfoHintProps) {
    return (
        <Tooltip
            label={label}
            multiline
            w={width}
            withArrow
            position={position}
            events={{ hover: true, focus: true, touch: true }}
            color="lmuTVColors.9"
        >
            <ActionIcon
                variant="subtle"
                size="sm"
                color="lmuTVColors.4"
                aria-label={label}
                style={{ cursor: "help" }}
            >
                <IconInfoCircle size={size} />
            </ActionIcon>
        </Tooltip>
    );
}
